import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { DataGridCell } from 'devextreme/excel_exporter';
import { BatchReportsGridEvent, JobDetail } from '../batch-reports-grid-types';
import { BatchReportsService } from '../batch-reports-service';
import query from 'devextreme/data/query';

@Component({
  selector: 'app-detail-grid',
  templateUrl: './detail-grid.component.html',
  styleUrls: ['./detail-grid.component.scss']
})
export class DetailGridComponent implements OnInit, AfterViewInit {

  //Here key is the report ref ID.
  @Input() key: string;
  detailsDataSource: DataSource;

  @Input()
  reportType: string;

  jobDetailsStore: ArrayStore;

  @Output() batchGridEvent = new EventEmitter<BatchReportsGridEvent>();


  jobDetails: JobDetail[];
  showRefreshButton: boolean = true;
  intervalId: number;
  constructor(private batchReportsService: BatchReportsService) { }

  ngOnInit(): void {
    this.startTimer();
  }

  startTimer() {
    var timer = 5;
    let that = this;
    if (this.intervalId) { clearInterval(this.intervalId) }
    this.intervalId = window.setInterval(function () {
      if (!that.showRefreshButton) { clearInterval(that.intervalId); return; }
      that.refresh();
      if (that.areAllJobsCompleted()) {
        that.showRefreshButton = false;
        clearInterval(that.intervalId);
      }
    }, 5000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  ngAfterViewInit() {

    this.jobDetailsStore = this.batchReportsService.getJobDetailsArrayStore();

    if (this.areAllJobsCompleted()) {
      this.showRefreshButton = false;
    }

    this.detailsDataSource = new DataSource({
      store: this.jobDetailsStore,
      filter: ['reportRefID', '=', this.key],
    });
  }

  onViewReportClicked() {
    let event = new BatchReportsGridEvent();

    event.subject = "report";
    event.eventType = "view_all_reports";
    event.key = this.key;

    this.batchGridEvent.emit(event);

  }

  refresh() {
    this.batchReportsService.refreshJobStatus(this.reportType, this.key);
  }

  areAllJobsCompleted() {
    var query = this.jobDetailsStore.createQuery()
    var notCompleted = query.filter([['reportRefID', '=', this.key], "and", ['status', '<>', 'Completed']]).toArray();
    return notCompleted.length == 0;
  }



}
